import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LoyaltyService, estimateCoins } from 'services/loyalty';
import { useTranslation } from 'i18n';

/** R5: "Earn ~N Zaynic Coins" under a product price. Hidden when coins are
 * off, the config can't load, or the amount earns nothing. */
export default function EarnCoinsHint({ amount, className = '' }) {
  const { t } = useTranslation();
  const [config, setConfig] = useState(null);

  useEffect(() => {
    let alive = true;
    LoyaltyService.getConfig().then((res) => { if (alive && res.success) setConfig(res.data); });
    return () => { alive = false; };
  }, []);

  const coins = estimateCoins(config, amount);
  if (!coins) return null;
  return (
    <p className={`text-xs font-semibold text-amber-800 ${className}`} data-testid="earn-coins-hint">
      <span aria-hidden>🪙 </span>
      {t('coins.earnHint', { count: coins })}{' '}
      <Link to="/coins/terms" className="font-medium text-muted underline-offset-2 hover:underline">
        {t('coins.howItWorks')}
      </Link>
    </p>
  );
}
